import Vue from "vue";
import { Toast } from "vant"
import i18n from '@/util/lang'

export default {
  install(app) {
    Vue.prototype.$copy = function(context) {
       if (!navigator.clipboard) {
        var ele = document.createElement("input");
        ele.value = context;
        document.body.appendChild(ele);
        ele.select();
        document.execCommand("copy");
        document.body.removeChild(ele);
        if (document.execCommand("copy")) {
            Toast.success(i18n.t('复制成功'));
        } else {
            Toast.error(i18n.t('复制失败'));
        }
    } else {
        navigator.clipboard.writeText(context).then(function () {
            Toast.success(i18n.t('复制成功'));
        }).catch(function () {
            Toast.error(i18n.t('复制失败'));
        })
    }
    };
  },
};



// WEBPACK FOOTER //
// src/plugin/common.js